import { lazy } from "react";

const NewMembersPage = lazy(() => import("./pages/NewMembersPage"));

export const newMembersRoutes = [
  { path: "/new-members", element: <NewMembersPage /> },
];
